import * as Yup from 'yup'
import {ShortDescription} from 'Validations'

const Validation = Yup.object().shape({
  reason: ShortDescription,
})

export default Validation
